import React, { Component } from 'react';

import APIDocsCurl from 'common/developers/docs/api/APIDocsCurl';
import APIDocsMethod from 'common/developers/docs/api/APIDocsMethod';
import Highlight from 'common/developers/docs/api/Highlight';

import APIDocsBlock from '../APIDocsBlock';
import APIDocsTable from '../APIDocsTable';

export default class APIDocsListVotesBlock extends Component {
  render() {
    return (
      <APIDocsBlock>
        <div>
          <div className="heading">List votes</div>
          <div className="text">
            Returns a list of votes. Include parameters to specify post, board, and&nbsp;pagination.
            Sorted by newest.
          </div>
          <APIDocsTable
            title="Arguments"
            rows={[
              {
                description: 'Your secret API key.',
                heading: 'apiKey',
                subheading: 'string',
              },
              {
                description: "The id of the board you'd like to fetch votes for.",
                heading: 'boardID',
                subheading: 'string (optional)',
              },
              {
                heading: 'companyID',
                subheading: 'string (optional)',
                description:
                  'If specified, will only fetch posts created by users linked to the company with this custom identifier.',
              },
              {
                description:
                  "The number of votes you'd like to fetch. Defaults to 10 if not specified.",
                heading: 'limit',
                subheading: 'number (optional)',
              },
              {
                description: 'Specify a postID to only fetch votes for a specific post.',
                heading: 'postID',
                subheading: 'string (optional)',
              },
              {
                description:
                  "The number of votes you'd like to skip before starting to fetch. Defaults to 0 if not specified.",
                heading: 'skip',
                subheading: 'number (optional)',
              },
              {
                description: 'Specify a userID to only fetch votes for a specific user.',
                heading: 'userID',
                subheading: 'string (optional)',
              },
            ]}
          />
          <div className="subheading">Returns</div>
          <div className="text">
            A dictionary with a "votes" property that contains an array of vote objects. There's
            also a "hasMore" property that specifies whether this query returns more votes than
            the&nbsp;limit.
          </div>
        </div>
        <div>
          <div className="text">Endpoint</div>
          <Highlight lang="http">https://canny.io/api/v1/votes/list</Highlight>
          <APIDocsMethod />
          <APIDocsCurl
            path="https://canny.io/api/v1/votes/list"
            body={`\\
    -d apiKey=YOUR_API_KEY \\
    -d postID=553c3ef8b8cdcd1501ba2468`}
          />
          <div className="text">Example Response</div>
          <Highlight lang="json">
            {`{
  "hasMore": false,
  "votes": [{
    "id": "553c3ef8b8cdcd1501ba123b",
    "board": {
      "created": "2017-07-10T11:22:00.000Z",
      "id": "553c3ef8b8cdcd1501ba1234",
      "name": "Feature Requests",
      "postCount": 123,
      "url": "https://your-company.canny.io/admin/board/feature-requests"
    },
    "by": null,
    "created": "2017-07-15T22:11:00.000Z",
    "post": {
      "category": {
        "id": "553c3ef8b8cdcd1501ba2234",
        "name": "Dashboard",
        "postCount": 42,
        "url": "https://your-company.canny.io/admin/board/feature-requests?category=dashboard"
      },
      "commentCount": 2,
      "id": "553c3ef8b8cdcd1501ba4444",
      "imageURLs": [],
      "jira": {
        "linkedIssues": [{
          "id": "123",
          "key": "ID-123",
          "url": "https://your-company.atlassian.net/browse/ID-123"
        }]
      },
      "score": 13,
      "status": "planned",
      "tags": [{
        "id": "553c3ef8b8cdcd1501ba3234",
        "name": "iOS",
        "postCount": 15,
        "url": "https://your-company.canny.io/admin/board/feature-requests?tags=ios"
      }],
      "title": "post-title",
      "url": "https://your-company.canny.io/admin/board/feature-requests/p/post-title"
    },
    "voter": {
      "id": "553c3ef8b8cdcd1501ba123a",
      "created": "2017-07-15T22:11:00.000Z",
      "email": "test@test.test",
      "isAdmin": false,
      "name": "Sally Doe",
      "url": "https://your-company.canny.io/admin/users/sally-doe",
      "userID": "1234"
    },
    "zendeskTicket": {
      "url": "https://your-company.zendesk.com/api/v2/tickets/2.json",
      "id": 2,
      "created": "2018-12-14T19:20:25Z",
      "subject": "Ticket subject",
      "description": "Ticket description",
    },
    "votePriority": "No priority",
  }]
}`}
          </Highlight>
        </div>
      </APIDocsBlock>
    );
  }
}
